import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { EmploymentStatus } from '@axo/shared/data-access/types';

export const grossIncomeMonthlyFieldOption = {
  registerOptions: {
    required: 'GrossIncomeMonthly.error.required',
    min: {
      value: 800,
      message: 'GrossIncomeMonthly.error.amount.low',
    },
    max: {
      value: 99_999,
      message: 'GrossIncomeMonthly.error.amount.high',
    },
  },
  warningValidation: {
    message: (value, form) => {
      const amount = Number(value);
      const employmentStatus = form?.['LoanApplication/EmploymentStatus'];

      if (employmentStatus === 'Student') {
        return 'GrossIncomeMonthly.error.soft.amount_student';
      }

      if (
        [
          EmploymentStatus.Permanent,
          EmploymentStatus.Entrepreneur,
          EmploymentStatus.Temporary,
        ].includes(employmentStatus)
      ) {
        if (amount < 1_000) {
          return 'GrossIncomeMonthly.error.soft.amount';
        }
      }
    },
  },
  tooltipValidation: {
    message: 'GrossIncomeMonthly.tooltip',
  },
} satisfies IFieldOptions;
